
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAggregateResultItemHypermediaRepresentation } from '../../shared/contracts/AggregateContract';
import Speedometer from '../overview/Speedometer.vue';
import Dashboard from './Dashboard.vue';
import DriverBreakdown from './DriverBreakdown.vue';
@Component({
    components: {
        Dashboard,
        Speedometer,
        DriverBreakdown
    }
})
export default class OverviewItem extends Vue {
    @Prop() item: IAggregateResultItemHypermediaRepresentation;
}
